import { Component } from '@angular/core'
import {
  AlertController,
  IonicPage,
  LoadingController,
  ModalController,
  NavController,
  NavParams,
  ToastController
} from 'ionic-angular'

import { DealStatus, Meeting, ShopOrder, ShopOrderStatus } from '../../models/models'
import { ApiProvider } from '../../providers/api/api'
import { OperatorProvider } from '../../providers/operator/operator'
import { SettingsProvider } from '../../providers/settings/settings'
import { AddMeetingPage } from '../add-meeting/add-meeting'
import { SelectAgreementPage } from '../select-agreement/select-agreement'
import { ContractsProvider } from '../../providers/api/contracts.provider'
import { AddCallPage } from '../add-call/add-call';
import { HttpClient } from "@angular/common/http";
import { UserAuthProvider } from "../../modules/mrk-user-auth/user-auth";
import { DepositPaymentMethodModal } from "./deposit-payment-method-modal/deposit-payment-method-modal";
import { filter, map, take } from 'rxjs/operators'

@IonicPage()
@Component({
  selector: 'page-meeting',
  templateUrl: 'meeting.html',
})
export class MeetingPage {

  meeting: Meeting = null
  shopOrder: ShopOrder
  isShopOrderPaid: boolean = false
  parent = null
  operator_id: any

  contractReady: boolean = false
  otpSigned: boolean = false
  shopId: number
  shopPlanQueryparam: string

  signContractUrl: string
  paymentUrl: string
  name: string

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private loading: LoadingController,
    private api: ApiProvider,
    private alertCtrl: AlertController,
    private toastCtrl: ToastController,
    private modalCtrl: ModalController,
    private operatorProvider: OperatorProvider,
    public settings: SettingsProvider,
    private readonly contractsProvider: ContractsProvider,
    private http: HttpClient,
    private userProvider: UserAuthProvider<any>) {
    if (typeof navParams.get('meeting') != 'undefined') {
      this.meeting = navParams.get('meeting')

      this.shopId = this.meeting.deal.conversion?.converted

      if (this.meeting.deal.shop_orders?.length) {
        this.shopOrder = this.meeting.deal.shop_orders[this.meeting.deal.shop_orders.length - 1]

        this.shopPlanQueryparam = this.shopOrder.rate.queryparam
        this.paymentUrl = `https://mypushop.com/contract-payments/${this.shopPlanQueryparam}/${this.meeting.deal.id}/`

        if (this.shopId) {
          this.checkContractStatus()
        }

        console.log(this.shopOrder.status)

        if (this.shopOrder.status === ShopOrderStatus.COMPLETED) {
          this.isShopOrderPaid = true;
        }
      }

      userProvider.userState.pipe(
        filter(state => state.logged),
        take(1),
        map(state => `${state.user.firstname} ${state.user.surname}`)
      ).subscribe(name => {
        this.name = name
      })
    }

    this.parent = (navParams && navParams.get('parent')) || null
    let operator = (navParams && navParams.get('operator')) || null
    this.operator_id = operator ? operator.id : 0

    this.operatorProvider.currentOperator.subscribe(operator => {
      if (operator) {
        this.operator_id = operator.id
      }
    })
  }

  get products(): String {
    return this.meeting?.deal?.product?.name || ""
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad MeetingPage');
  }

  get meetingStatus() {
    switch (this.meeting.status) {
      case this.settings.MEETING_PLANNED:
        return "Pianificato"
      case this.settings.MEETING_DONE:
        return "Fatto"
      default:
        return "Annullato"
    }
  }

  checkContractStatus() {
    this.http.get<{ has_signed: boolean, sign_contract_url: string }>(
      `${this.userProvider.config.baseURL}api/otp/data/for_seller/?shop=${this.shopId}&queryparam=${this.shopPlanQueryparam}`
    ).subscribe(res => {
      this.otpSigned = res.has_signed
      this.signContractUrl = res.sign_contract_url
    })
  }

  copyUrl(type: string) {
    let url: string

    if (type === 'payment') {
      url = this.paymentUrl
    } else if (type === 'sign_contract') {
      url = this.signContractUrl
    }

    if (url) {
      const el = document.createElement('textarea');
      el.value = url;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);

      this.alertCtrl.create({
        message: 'Link copiato!',
        buttons: ['Ok']
      }).present().then()
    }
  }

  goToAgreement(type) {
    if (this.shopOrder) {
      this.redirectToShopRegistrationPage();
    } else {
      this.navCtrl.push(SelectAgreementPage, {
        meeting: this.meeting,
        type: type,
        parent: this,
      })
    }
    // apro link
  }

  redirectToShopRegistrationPage() {
    window.open(
      `https://admin.mypushop.com/accept/${this.shopOrder.rate.queryparam}/${this.meeting.deal.id}/`,
      '_blank'
    )
    this.navCtrl.pop()
  }

  redirectToAddCardPage() {
    window.open(
      `https://admin.mypushop.com/contract-add-card/${this.shopOrder.rate.queryparam}/${this.shopOrder.deal}/`,
      '_blank'
    )
    this.navCtrl.pop()
  }

  call() {
    window.open('tel:' + this.meeting.deal.contact.phone, '_system', 'location=yes')
  }

  finalizeContract() {
    let finalize = () => {
      let finalizeUrl = "https://admin.mypushop.com/contract/finalization/" + this.meeting.deal.id + "/"
      var win = window.open(finalizeUrl, '_blank')
      win.focus()
    }

    if (this.otpSigned) {
      finalize()
    } else {
      this.alertCtrl.create({
        title: 'Sei sicuro?',
        message: `Il contratto non è ancora stato firmato tramite OTP.
                  Vuoi Procedere con la finalizzazione di un contratto cartaceo?`,
        buttons: [
          'Annulla',
          {
            text: 'Procedi',
            handler: finalize
          }
        ]
      }).present().then()
    }
  }

  // NEW BUTTON

  meetingUnDone() {

    // Chiedo Conferma

    this.alertCtrl.create({
      title: "Appuntamento non fatto",
      message: "Confermi la scelta?",
      buttons: [
        {
          text: "Indietro",
          handler: () => {
          }
        },
        {
          text: "Conferma",
          handler: () => {

            // Aggiorno Stato appuntamento

            let l = this.showLoader()
            this.meeting.status = this.settings.MEETING_CANCEL

            this.api.patchMeeting(this.operator_id, this.meeting).subscribe(
              _ => {

                // Aggiorno elenco appuntamenti

                this.parentRefresh()

                l.dismiss()

                this.alertCtrl.create({
                  title: "Fissa Nuovo Appuntamento",
                  message: "Vuoi fissare un nuovo appuntamento?",
                  buttons: [
                    {
                      text: "No",
                      handler: () => {

                        // Aggiorno Stage Attuale

                        let l = this.showLoader()
                        this.meeting.deal.current_stage = this.settings.STAGE_APPOINTMENT_UNDONE_BY_PRODUCT[this.meeting.deal.product.ac_label]
                        this.api.patchDeal(this.meeting.deal).subscribe(_ => {
                          l.dismiss()
                        }, _e => {
                          l.dismiss()
                        })
                      }
                    },
                    {
                      text: "Si",
                      handler: () => {

                        // Sposto appuntamento

                        this.moveMeeting()

                      }
                    }
                  ]
                }).present()
              },
              _e => {
                l.dismiss()
              })
          }
        }
      ]
    }).present()

  }


  meetingDone() {
    // Chiedo Conferma

    this.alertCtrl.create({
      title: "Appuntamento Fatto",
      message: "Confermi la scelta?",
      buttons: [
        {
          text: "Indietro",
          handler: () => {
          }
        },
        {
          text: "Conferma",
          handler: () => {

            // Aggiorno Stato appuntamento

            let l = this.showLoader()
            this.meeting.status = this.settings.MEETING_DONE
            this.meeting.deal.current_stage = this.settings.STAGE_APPOINTMENT_DONE_BY_PRODUCT[this.meeting.deal.product.ac_label]
            this.api.patchMeeting(this.operator_id, this.meeting)
              .concatMap(_meeting => this.api.patchDeal(this.meeting.deal))
              .subscribe(
                _ => {
                  // Aggiorno elenco appuntamenti
                  this.parentRefresh()

                  l.dismiss()
                  this.notifyOk()
                },
                _e => {
                  l.dismiss()
                  this.notifyError()
                }
              )
          }
        }
      ]
    }).present()

  }

  conversionLost() {
    const conversionId = this.meeting.deal.conversion.id
    this.contractsProvider.setAslost(conversionId).subscribe(
      deal => {
        this.meeting.deal = deal
        this.notifyOk()
      },
      _e => {
        this.notifyError()
      }
    )
  }

  dealLost() {
    if (this.meeting.deal.status === DealStatus.WON) {
      this.notifyError()
      return
    }

    this.meeting.deal.status = this.settings.DEAL_LOST
    this.api.setDealAsLost(this.meeting.deal.id).subscribe(
      _ => {
        this.notifyOk()
      },
      _e => {
        this.notifyError()
      }
    )
  }

  notifyOk() {
    this.toastCtrl.create({
      message: 'Operazione conclusa con successo',
      duration: 2000,
      position: 'top'
    }).present()
    this.parentRefresh()
  }

  notifyError(e: string = "") {
    this.toastCtrl.create({
      message: 'Si è verificato un errore ' + e,
      duration: 2000,
      position: 'top'
    }).present()
    this.parentRefresh()
  }


  cancelMeeting() {

    let meeting = { ...this.meeting }
    this.alertCtrl.create({
      title: "Conferma operazione",
      message: "Confermi di voler annullare l'appuntamento?",
      buttons: [
        {
          text: 'Annulla',
          handler: () => {
          }
        },
        {
          text: 'Si, Conferma',
          handler: () => {
            let l = this.loading.create({
              content: "Attendere.."
            })
            l.present()
            meeting.status = this.settings.MEETING_CANCEL
            this.api.patchMeeting(this.operator_id, meeting)
              .concatMap(meeting => {

                meeting.deal.current_stage = this.settings.STAGE_APPOINTMENT_UNDONE_BY_PRODUCT[this.meeting.deal.product.ac_label]
                return this.api.patchDeal(meeting.deal)
              }).subscribe(
                _deal => {
                  l.dismiss()
                  this.meeting = meeting
                  this.toastCtrl.create({
                    message: 'Appuntamento annullato con successo',
                    duration: 2000,
                    position: 'top'
                  }).present()
                  this.parentRefresh()
                },
                _e => {
                  l.dismiss()
                  this.toastCtrl.create({
                    message: 'Si è verificato un errore',
                    duration: 2000,
                    position: 'top'
                  }).present()
                }
              )
          }
        }
      ]
    }).present()


  }

  showLoader() {
    let l = this.loading.create({
      content: "Attendere.."
    })
    l.present()
    return l
  }

  moveMeeting() {
    let meetingModal = this.modalCtrl.create(AddMeetingPage,
      {
        contact: this.meeting.deal.contact,
        deal: this.meeting.deal,
        silent: true,
        notes: this.meeting.notes,
        place: this.meeting.place
      })
    meetingModal.onDidDismiss(value => {
      if (value != null) {
        this.toastCtrl.create({
          message: 'Appuntamento spostato con successo',
          duration: 2000,
          position: 'top'
        }).present()
        this.parentRefresh()
      } else {
        this.toastCtrl.create({
          message: 'Si è verificato un errore',
          duration: 2000,
          position: 'top'
        }).present()
      }

    })
    meetingModal.present()
  }

  operatorName(): string {
    if (typeof this.meeting.operator !== 'number') {
      return `${this.meeting.operator.user.firstname} ${this.meeting.operator.user.surname}`
    }

    return ''
  }

  parentRefresh() {
    this.parent && this.parent.refresh && this.parent.refresh()
  }

  setHot() {
    this.api.markDealAsHot(this.meeting.deal.id, true).subscribe(deal => {
      this.meeting.deal = deal
      this.notifyOk()
    }, _e => {
      this.notifyError()
    })
  }

  newCall() {
    let contact = this.meeting.deal.contact
    if (contact != null) {
      console.log('Creo un call con', contact.name)
      let callModal = this.modalCtrl.create(AddCallPage, {
        contact: contact,
        deal: this.meeting.deal
      }, { showBackdrop: true })
      callModal.onDidDismiss(_value => {
      })
      callModal.present()
    }
  }

  openDepositPayMethodModal() {
    let modal = this.modalCtrl.create(DepositPaymentMethodModal, { shopOrderId: this.shopOrder.id })
    modal.onDidDismiss(() => this.navCtrl.pop())
    modal.present().then()
  }
}



// WEBPACK FOOTER //
// ./src/pages/meeting/meeting.ts